import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

import './assets/css/minireset.min.css'
import './assets/css/fonts.css'

import './stylus/main.styl'
// eslint-disable-next-line
import $ from 'jquery'

import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'GTM-P5JSM4P',
  router /*,
  checkDuplicatedScript: true,
  autoTracking: {
    screenview: true
  },
  set: [
    { siteName: 'http://oecdregionalwellbeing.org/', siteEnvironment: 'live' }
  ],
  debug: {
    enabled: true
  } */
})


Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
